export default __webpack_public_path__ + "static/media/UNNATI Preparation of GPDP Operating Framework and Template 14 Oct 2019.2ddd7b73.pdf";